<template>
  <v-container id="ur-list">
    <v-row>
      <v-col
        ><h3><b>Tipo Solução</b></h3></v-col
      >
      <v-col class="text-right">
        <app-modal-insert
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
        >
          <template v-slot:title :edit="false">
            Cadastrar Tipo Solução
          </template>
        </app-modal-insert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.temaId="{ item }">
            <span>
              {{ item.solucaoTipoNome }}
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                >
                  <template v-slot:title> Editar Tipo Solução </template>
                </app-modal-insert>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete :object="item">
                  <template v-slot:title> Deletar </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum Tipo Solução retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsert from "./ModalInsert";
import { tipoSolucaoAPI } from "../API/TipoSolucaoAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";
export default {
  components: {
    AppModalInsert,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "solucaoTipoNome" },
        { text: "Editar", value: "acoes", width: "10%", sortable: false },
        {
          text: "Excluir",
          value: "acoes_delete",
          width: "10%",
          sortable: false,
        },
      ],
      payload: [],
      mappedPayload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      this.setLoading(true);
      tipoSolucaoAPI
        .list()
        .then(({ data }) => {
          this.payload = data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Tipo Solução");
        });
    },
  },
  async mounted() {
    this.load();
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
};
</script>
